/** Bateria, nível travado, nível oscilante, nível fora dos limites e chuva suspeita. */
export const TIPOS_EVENTO_TOTAL_IRREGULAR = [1, 3, 4, 5, 9];

function numero(valor: any): number {
  const n = Number(valor);
  return Number.isFinite(n) ? n : 0;
}

function temValor(valor: any): boolean {
  return valor !== null && valor !== undefined && valor !== '';
}

export function normalizarEventoDialog(evento: any): any {
  if (!evento) {
    return evento;
  }

  const tipo = Number(evento.tipo_evento_id);
  const usaIrregular = TIPOS_EVENTO_TOTAL_IRREGULAR.includes(tipo);
  const total = usaIrregular && temValor(evento.total_computado_irregular)
    ? numero(evento.total_computado_irregular)
    : numero(evento.total_computado);

  let tooltip = evento.tooltip;
  if (tipo === 3) {
    const maximo = evento.maximo_normalidade_eventos ?? 0;
    tooltip = `Foram encontrados ${total} dados iguais (H = H-1) durante o dia. O máximo de dados iguais são ${maximo} ao dia.`;
  }

  return {
    ...evento,
    total_computado: total,
    tooltip,
  };
}

export function normalizarDialogEstacao(dialogo: any): any {
  if (!dialogo || !Array.isArray(dialogo.eventos)) {
    return dialogo;
  }

  return {
    ...dialogo,
    eventos: dialogo.eventos.map(normalizarEventoDialog),
  };
}
